import { Element } from 'slate';
import { LtiEntity } from '../../Entities';
import { BlockElement } from '../../types';

export const echo360Type = 'echo360';

// type guard
export const isEcho360Element = (element: Element): element is BlockElement =>
  element.type === echo360Type;

/** An LTI block is accepted to be in the progress of loading data,
 *  if its data  field is  empty. Currently, Echo 360  LTI  blocks
 *  don't receive message after content selection so a random link
 *  id is explicitly set immediately after adding the block to the
 *  document.
 */
export type Echo360Entity = LtiEntity & {
  data: { linkId: string };
};
